<template>
  <div class="footer" v-if="this.isExperienceEditor || this.shouldDisplay">
    <sc-placeholder name="jssfootercontent" :rendering="rendering" />
  </div>
</template>

<script>
import { isExperienceEditorActive, Placeholder } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'Footer',
  data() {
    return {
      loggedIn: false,
    };
  },
  props: {
    rendering: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Object,
    },
  },
  mounted() {
    this.onUrlChange();
  },
  updated() {
    this.onUrlChange();
  },
  methods: {
    async onUrlChange() {
      if (typeof this.$auth != 'undefined') {
        const isAuthenticated = await this.$auth.isAuthenticated();
        const user = await this.$auth.userDetails;
        if (isAuthenticated && user.hasAgreedChallengerTerms) {
          this.loggedIn = true;
        } else {
          this.loggedIn = false;
        }
      }
    },
  },
  computed: {
    isExperienceEditor() {
      // Todo may need to add other check like preview mode in SC editor...
      return isExperienceEditorActive();
    },
    shouldDisplay() {
      if (this.params) {
        if((typeof(this.params.DisplayWhenLoggedIn)=='undefined'||this.params.DisplayWhenLoggedIn !== '1') 
          && !this.loggedIn){
          return true;
        }
        else if (this.params.DisplayWhenLoggedIn == '1' && this.loggedIn)
        {
          return true;
        }
      }
      return false;
    },
  },
  components: {
    ScPlaceholder: Placeholder,
  },
};
</script>
<style lang="scss" scoped>
.footer {
  background-color: #1e1e1e;
  color: white;
  padding: 0;

  @media print {
    display: none;
  }
}
</style>
